module.exports = __webpack_public_path__ + "img/XL_LOGO_INOE_MOBI.57fed7e4.svg";